const LAST_SUBMITTED_EMAIL_CACHE_KEY = 'lastSubmittedEmail';

export const getLastSubmittedEmail = () => {
  try {
    return localStorage.getItem(LAST_SUBMITTED_EMAIL_CACHE_KEY);
  } catch (err) {
    // there are cases when `localStorage` is unavailable
    return;
  }
};

export const storeLastSubmittedEmail = (email) =>
  localStorage.setItem(LAST_SUBMITTED_EMAIL_CACHE_KEY, email);
